{
  "OrganizationTalentsPage": {
    "title": "Talenty organizacji"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "Konfiguruj typy zasobów",
    "heading": "Konfiguruj typy zasobów",
    "allTypes": "Wszystkie typy",
    "global": "W tej organizacji",
    "workspace": "W tej przestrzeni",
    "thisTypeInWorkspace": "{{name}} w tej przestrzeni"
  },
  "ResourceRowGallery": {
    "failedToLoad": "Nie udało się załadować pinów",
    "empty": "Brak pinów",
    "addContactPins": "Dodaj piny",
    "label": "Piny"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "Przypisz do przestrzeni roboczych",
    "description_one": "Wybierz widoczność {{name}} w przestrzeniach roboczych.",
    "description_other": "Wybierz widoczność tych {{count}} zasobów w przestrzeniach roboczych.",
    "fieldScope": "Widoczność",
    "scopeHidden": "Ukryty",
    "scopeHiddenHint": "Brak członkostwa — niewidoczny na listach (tylko admin).",
    "scopeGlobal": "Globalny",
    "scopeGlobalHint": "Widoczny w każdej przestrzeni (wiersz członkostwa bez id przestrzeni).",
    "scopeWorkspaces": "Wybrane przestrzenie",
    "fieldWorkspaces": "Przestrzenie robocze",
    "workspacesSelectPrompt": "Wybierz jedną lub więcej przestrzeni roboczych",
    "workspacesSelectedCount": "Wybrano: {{count}}",
    "workspacesUnselectAll": "Odznacz wszystkie",
    "workspacesEmpty": "Brak dostępnych przestrzeni roboczych",
    "save": "Przypisz",
    "assignFailed": "Nie udało się przypisać przestrzeni roboczych",
    "unsavedChangesBeforeUnload": "Masz niezapisane zmiany!",
    "success_one": "Zasób przypisany do przestrzeni roboczych",
    "success_other": "Przypisano {{count}} zasobów do przestrzeni roboczych"
  },
  "ResourceWorkspacesCell": {
    "hidden": "Ukryty",
    "global": "Globalny"
  },
  "ResourceCreateForm": {
    "profilePicture": "Zdjęcie profilowe",
    "resourceType": "Typ zasobu"
  },
  "ResourceCreateDialog": {
    "title": "Utwórz zasób",
    "titleTypeAndVisibility": "Utwórz zasób · typ i widoczność",
    "titleType": "Utwórz zasób · typ",
    "titleDetails": "Utwórz zasób · szczegóły",
    "description": "Utwórz nowy zasób",
    "actions": {
      "add-another": "Zapisz i dodaj kolejny",
      "go-to-profile": "Zapisz i przejdź do profilu",
      "close": "Zapisz"
    },
    "createFailed": "Nie udało się utworzyć zasobu",
    "noResourceTypes": "Brak dostępnych typów zasobów."
  },
  "CreateDraftSummary": {
    "change": "Zmień"
  },
  "ResourceDuplicatesFooter": {
    "title": "Wygląda znajomo?",
    "titleExact": "Ktoś o tej nazwie już istnieje",
    "summary_one": "{{count}} istniejący zasób ma podobną nazwę",
    "summary_few": "{{count}} istniejące zasoby mają podobną nazwę",
    "summary_many": "{{count}} istniejących zasobów ma podobną nazwę",
    "summary_other": "{{count}} istniejących zasobów ma podobną nazwę",
    "summaryNamed_one": "{{count}} istniejący zasób przypomina „{{name}}”",
    "summaryNamed_few": "{{count}} istniejące zasoby przypominają „{{name}}”",
    "summaryNamed_many": "{{count}} istniejących zasobów przypomina „{{name}}”",
    "summaryNamed_other": "{{count}} istniejących zasobów przypomina „{{name}}”",
    "review": "Sprawdź",
    "hide": "Ukryj",
    "dismiss": "Odrzuć",
    "exactMatch": "Ta sama nazwa",
    "similarMatch": "Podobny",
    "openProfile": "Otwórz",
    "openProfileOf": "Otwórz profil {{name}} w nowej karcie",
    "hint": "Profile otwierają się w nowej karcie, więc szkic zostaje tutaj. To inna osoba? Po prostu zapisz."
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "Imię i nazwisko",
      "pronouns": "Zaimki",
      "emails": "Adresy e-mail",
      "phoneNumbers": "Numery telefonów",
      "socials": "Media społecznościowe",
      "websites": "Strony internetowe",
      "tags": "Tagi",
      "groups": "Grupy",
      "locations": "Lokalizacje",
      "rates": "Stawki",
      "agent": "Agent",
      "organization": "Organizacja",
      "nickname": "Pseudonim",
      "role": "Rola"
    },
    "enterPlaceholder": "Wpisz: {{label}}",
    "globalSection": "Globalne",
    "emptyWorkspaceSection": "Brak pól specyficznych dla {{workspaceName}}",
    "locationItemTitle": "Lokalizacja",
    "rateItemTitle": "Stawka",
    "addRate": "Dodaj stawkę",
    "blankRate": "Pusta stawka",
    "blankRateHint": "Wpisz kwotę",
    "fromRateCard": "Z karty stawek",
    "addItem": "Dodaj: {{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "Edytor zasobu",
    "newVersionDescription": "Testujesz nowy edytor. To wciąż wersja eksperymentalna — jeśli coś nie działa, wróć do klasycznej. Twoje dane się nie zmieniają.",
    "oldVersionDescription": "Używasz klasycznego edytora. Nowy jest w wersji beta — możesz go wypróbować w każdej chwili."
  },
  "ResourceNotesPanel": {
    "title": "Notatki",
    "fieldLabel": "Nowa notatka",
    "placeholder": "Napisz notatkę…",
    "submit": "Dodaj notatkę",
    "emptyTitle": "Brak notatek",
    "emptyDescription": "Zapisuj notatki o {{name}}.",
    "fallbackName": "tym zasobie",
    "loadError": "Nie udało się wczytać notatek.",
    "unknownUser": "Nieznany użytkownik",
    "deleteAria": "Usuń notatkę",
    "createdToast": "Notatka dodana",
    "createErrorToast": "Nie udało się dodać notatki",
    "deletedToast": "Notatka usunięta",
    "deleteErrorToast": "Nie udało się usunąć notatki"
  },
  "ResourceFilesPanel": {
    "title": "Dokumenty",
    "emptyTitle": "Brak dokumentów",
    "emptyDescription": "Przechowuj ważne dokumenty i pliki dla {{name}}.",
    "fallbackName": "tego zasobu",
    "loadError": "Nie udało się wczytać dokumentów.",
    "untitled": "Plik bez nazwy",
    "uploadedToast": "Plik przesłany",
    "uploadErrorToast": "Przesyłanie nie powiodło się",
    "reorderErrorToast": "Nie udało się zapisać nowej kolejności"
  },
  "ResourcePane": {
    "invalidDataDescription": "Mimo to pokazujemy ten formularz, ale może działać nieprawidłowo. Jeśli napotkasz problemy, skontaktuj się z pomocą."
  },
  "Pinboard": {
    "title": "Tablica",
    "addPins": "Dodaj piny",
    "filterByTag": "Filtruj po tagu",
    "tags": "Tagi",
    "countFiltered_one": "{{count}} z {{total}} pinów",
    "countFiltered_few": "{{count}} z {{total}} pinów",
    "countFiltered_many": "{{count}} z {{total}} pinów",
    "countFiltered_other": "{{count}} z {{total}} pinów",
    "noMatchesTitle": "Żaden pin nie ma tych tagów",
    "noMatches": "Wybierz inne tagi albo wyczyść filtr, żeby zobaczyć wszystkie piny.",
    "emptyReadOnly": "Piny pokazują przykłady pracy i ważne informacje o osobie.",
    "loading": "Wczytywanie pinów",
    "toast": {
      "undo": "Cofnij",
      "added": "Dodano pin",
      "addFailed": "Nie udało się dodać pina",
      "addedMany_one": "Dodano pin",
      "addedMany_few": "Dodano {{count}} piny",
      "addedMany_many": "Dodano {{count}} pinów",
      "addedMany_other": "Dodano {{count}} pinów",
      "addedPartly_one": "Dodano {{added}}, nie udało się dodać {{count}} pina",
      "addedPartly_few": "Dodano {{added}}, nie udało się dodać {{count}} piny",
      "addedPartly_many": "Dodano {{added}}, nie udało się dodać {{count}} pinów",
      "addedPartly_other": "Dodano {{added}}, nie udało się dodać {{count}} pinów",
      "addFailedMany_one": "Nie udało się dodać pina",
      "addFailedMany_few": "Nie udało się dodać {{count}} piny",
      "addFailedMany_many": "Nie udało się dodać {{count}} pinów",
      "addFailedMany_other": "Nie udało się dodać {{count}} pinów",
      "deleted_one": "Usunięto pin",
      "deleted_few": "Usunięto {{count}} piny",
      "deleted_many": "Usunięto {{count}} pinów",
      "deleted_other": "Usunięto {{count}} pinów",
      "deleteFailed_one": "Nie udało się usunąć pina",
      "deleteFailed_few": "Nie udało się usunąć {{count}} pinów",
      "deleteFailed_many": "Nie udało się usunąć {{count}} pinów",
      "deleteFailed_other": "Nie udało się usunąć {{count}} pinów",
      "updated": "Zaktualizowano pin",
      "updateFailed": "Nie udało się zaktualizować pina",
      "profilePictureSaved": "Zapisano zdjęcie profilowe",
      "profilePictureFailed": "Nie udało się ustawić zdjęcia profilowego",
      "reorderFailed": "Nie udało się zapisać nowej kolejności"
    },
    "card": {
      "untitled": "Bez nazwy",
      "actions": "Akcje: {{name}}",
      "editTags": "Edytuj tagi",
      "setAsProfilePicture": "Ustaw jako zdjęcie profilowe",
      "download": "Pobierz",
      "openLink": "Otwórz link",
      "delete": "Usuń pin"
    },
    "add": {
      "title": "Dodaj piny",
      "description": "Zdjęcia, filmy, dokumenty i linki, widoczne na tablicy.",
      "formats": "Zdjęcia, filmy, PDF-y i inne pliki · wklej ⌘V",
      "orAddLink": "Albo dodaj link"
    },
    "link": {
      "hint": "Zdjęcie, film z YouTube lub Vimeo albo dowolna strona.",
      "notAUrl": "To nie jest link",
      "notAUrlHint": "Wklej adres, np. https://example.com/photo.jpg.",
      "brokenPicture": "Zdjęcie się nie wczytało",
      "brokenPictureHint": "Sprawdź adres albo pobierz zdjęcie i je wyślij.",
      "missingVideo": "Nie znaleziono filmu",
      "missingVideoHint": "Sprawdź, czy film istnieje i jest publiczny.",
      "page": "Strona internetowa"
    },
    "pin": "pin",
    "pins": "pinów",
    "deleteSelected_one": "Usuń {{count}} pin",
    "deleteSelected_few": "Usuń {{count}} piny",
    "deleteSelected_many": "Usuń {{count}} pinów",
    "deleteSelected_other": "Usuń {{count}} pinów"
  },
  "ResourceAside": {
    "title": "Przegląd",
    "expand": "Rozwiń panel",
    "collapse": "Zwiń panel",
    "fallbackName": "ten zasób",
    "heroNow": "Teraz: {{status}}",
    "heroUntil": "do {{date}}",
    "heroNext": "Następnie: {{status}}",
    "heroEmpty": "Nic w planie",
    "heroEmptyDetail_one": "Najbliższy {{count}} dzień jest pusty",
    "heroEmptyDetail_few": "Najbliższe {{count}} dni są puste",
    "heroEmptyDetail_many": "Najbliższe {{count}} dni są puste",
    "heroEmptyDetail_other": "Najbliższe {{count}} dnia są puste",
    "startsTomorrow": "Jutro",
    "startsInDays_one": "za {{count}} dzień",
    "startsInDays_few": "za {{count}} dni",
    "startsInDays_many": "za {{count}} dni",
    "startsInDays_other": "za {{count}} dnia",
    "scheduleTitle": "Grafik",
    "scheduleAdd": "Dodaj dostępność",
    "scheduleNow": "Teraz",
    "scheduleEmpty": "Zaznacz, kiedy {{name}} będzie następnym razem dostępny.",
    "scheduleCalendar": "Otwórz kalendarz",
    "scheduleCalendarMore_one": "Otwórz kalendarz · jeszcze {{count}}",
    "scheduleCalendarMore_few": "Otwórz kalendarz · jeszcze {{count}}",
    "scheduleCalendarMore_many": "Otwórz kalendarz · jeszcze {{count}}",
    "scheduleCalendarMore_other": "Otwórz kalendarz · jeszcze {{count}}",
    "shortlistsTitle": "Shortlisty",
    "shortlistsAdd": "Dodaj do shortlisty",
    "shortlistsMenu": "Akcje shortlisty",
    "shortlistsRemove": "Usuń z shortlisty",
    "shortlistsEmpty": "Shortlisty, do których dodano {{name}}, pojawią się tutaj.",
    "shortlistsError": "Nie udało się wczytać shortlist.",
    "previewError": "Nie udało się wczytać.",
    "notesTitle": "Notatki",
    "notesEmpty": "Brak notatek o {{name}}.",
    "notesOpen": "Otwórz notatki",
    "documentsTitle": "Dokumenty",
    "documentsEmpty": "Brak dokumentów dla {{name}}.",
    "documentsOpen": "Otwórz dokumenty",
    "untitledFile": "Plik bez nazwy",
    "shortlistPublished": "Opublikowana",
    "shortlistDraft": "Szkic",
    "shortlistCount": "{{count}} na shortliście"
  },
  "ContactPeopleList": {
    "title": "Osoby",
    "addResources": "Dodaj zasoby",
    "addFirst": "Dodaj pierwszą osobę",
    "emptyTitle": "Brak osób",
    "noMatchTitle": "Nie znaleziono osób",
    "emptyMessageOrganisation": "Dodaj osoby, które pracują dla tej organizacji.",
    "emptyMessageAgent": "Dodaj osoby, które reprezentuje ten agent.",
    "removeFromOrganisation": "Usuń z organizacji",
    "removeFromAgent": "Usuń od agenta",
    "confirmOrganisation": "Usunąć zaznaczone osoby z tej organizacji? Zostają w kontaktach.",
    "confirmAgent": "Usunąć zaznaczone osoby od tego agenta? Zostają w kontaktach.",
    "confirmRemove": "Usuń",
    "removedToast": "Usunięto: {{count}}.",
    "removedPartialToast": "Usunięto: {{removed}}. Niepowiązane tutaj, pozostawione bez zmian: {{notLinked}}.",
    "removeFailedToast": "Nie udało się usunąć zaznaczonych osób"
  },
  "ContactPeopleAddResources": {
    "title": "Dodaj zasoby",
    "pick": "Wybierz do: {{name}}",
    "linked": "Już dodano",
    "noResults": "Nie znaleziono zasobów",
    "noLinkableTypes": "Żadnego typu zasobu nie można tu powiązać z {{name}}.",
    "add": "Dodaj do: {{name}}",
    "added_one": "Dodano {{count}} osobę do: {{name}}",
    "added_few": "Dodano {{count}} osoby do: {{name}}",
    "added_many": "Dodano {{count}} osób do: {{name}}",
    "added_other": "Dodano {{count}} osoby do: {{name}}",
    "addFailed": "Nie udało się dodać wszystkich do: {{name}}. Spróbuj ponownie."
  }
}
